import React, {useState, useEffect, useRef} from "react";
import {Image} from "@nextui-org/react";
import {Button} from "@nextui-org/react";
import OutlookLogo from '../src/assets/images/outlook-image.png'
import GmailLogo from '../src/assets/images/gmail-image.png'
import emailTemplates from './emailTemplates.json';
import ImageComposeSection from '../src/assets/images/Vortexi-Compose.png'
import emailTypes from './emailTypes.json';
import {Card, CardHeader, CardBody} from "@nextui-org/card";
import {ScrollShadow} from "@nextui-org/react";
import {Divider} from "@nextui-org/divider";
import {Clock, Layout, Rocket, CircleCheck} from 'lucide-react';
import {gsap} from 'gsap';

const Home = () => {
    const [currentType, setCurrentType] = useState('All');
    const [templates, setTemplates] = useState([]);
    const headingRef = useRef(null);
    const subheadingRef = useRef(null);
    const buttonRef = useRef(null);
    const templateRef = useRef(null)

    const handleTypeClick = (type) => {
        setCurrentType(type);
    };



    const shuffleArray = (array) => {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    };

    const filteredTemplates = currentType === 'All'
        ? shuffleArray(templates)
        : templates.filter((templateGroup) => templateGroup.type === currentType);
    const handleClickTemplate = (subject, context) => {

    };
    useEffect(() => {
        setTemplates(emailTemplates);
        gsap.from([headingRef.current, subheadingRef.current, buttonRef.current, templateRef.current], {
            y: '50%',
            opacity: 0,
            duration: 2,
            stagger: 0.2,
            ease: 'power3.out'
        });
    }, []);

    function openUrlInNewTab(url) {
        if (url) {
            window.open(url, '_blank');
        } else {
            console.error('Invalid URL');
        }
    }


    const [benefits] = useState([
        {
            icon: <Clock color="#6B727A" size={28} strokeWidth={1} />,
            title: 'Save Time',
            description: 'Quickly find and use pre-designed templates for various email scenarios, eliminating the need to start from scratch.',
        },
        {
            icon: <Layout color="#6B727A" size={28} strokeWidth={1} />,
            title: 'Ensure Consistency',
            description: 'Maintain a professional and consistent tone across your emails.',
        },
        {
            icon: <Rocket color="#6B727A" size={28} strokeWidth={1} />,
            title: 'Improve Efficiency',
            description: 'Streamline your email composition process and reduce the time spent drafting emails.',
        },
        {
            icon: <CircleCheck color="#6B727A" size={28} strokeWidth={1} />,
            title: 'Access on-the-go',
            description: 'Easily access our template gallery directly from the popup, without needing to switch between different applications.',
        },
    ]);

    return (
        <div>
            <div class="container mx-auto px-9 relative flex flex-col items-center gap-2.5 md:border-2 py-6 rounded-3xl min-h-[100%] mb-12">
                <p ref={headingRef} className="text-2xl md:text-6xl text-center font-montserrat-bold">
                    Never start emails from scratch choose our Templates!
                </p>
                <p ref={subheadingRef} className="text-center md:text-lg max-w-[700px] text-xs">
                    Our Chrome extension offers fully customizable email templates that you can adjust and send directly to your recipients — all from a single popup.
                </p>
                <div ref={buttonRef} className="py-12">
                    <Button className="rounded-full" color="primary" size="md" variant="solid"
                        onClick={() => openUrlInNewTab('https://chromewebstore.google.com/detail/vortexi/chagdghinejpldgfbkjhnalpaajaifbo')}>Download for free </Button>
                </div>
                <div className="container mx-auto">
                    <div className="flex flex-col" ref={templateRef}>
                        <div className="flex flex-col items-center gap-2">
                            <p className=" text-lg text-center">
                                Templates made for you
                            </p>
                            <ScrollShadow orientation="horizontal" className="max-w-[400px] overflow-x-auto">
                                <div className="w-[1000px] p-5 flex">
                                    {emailTypes.map((type, index) => (
                                        <Button
                                            key={index}
                                            variant={'none'}
                                            className={` rounded-full inline-flex items-center px-2 py-1 cursor-pointer
                                                ${currentType === type ? 'bg-blue-500 text-white' : ''}`}
                                            onClick={() => handleTypeClick(type)}
                                        >
                                            {type}
                                        </Button>
                                    ))}
                                </div>
                            </ScrollShadow>
                        </div>
                        <div className="py-5">
                            <ScrollShadow orientation="horizontal" className="overflow-x-auto">
                                <div className="flex gap-3 p-4">
                                    {filteredTemplates.map((templateGroup) => (
                                        <div key={templateGroup.type} className="flex gap-4">
                                            {templateGroup.templates.map((template, index) => (
                                                <Card
                                                    key={index}
                                                    className="cursor-pointer duration-200 hover:border-black w-[250px] mb-2"
                                                    onClick={() =>
                                                        handleClickTemplate(template.subject, template.context)
                                                    }
                                                >
                                                    <CardHeader className="gap-2 flex flex-col">
                                                        <div
                                                            className="inline-flex items-center px-2 py-1 flex-grow: 0"
                                                        >
                                                            {templateGroup.type}
                                                        </div>
                                                        <CardBody className="flex flex-col gap-2">
                                                            <div className="text-sm whitespace-normal break-words line-clamp-2 text-ellipsis overflow-hidden">
                                                                {template.subject}
                                                            </div>
                                                            <p className="text-xs whitespace-normal break-words line-clamp-5 text-ellipsis overflow-hidden">
                                                                {template.context}
                                                            </p>
                                                        </CardBody>
                                                    </CardHeader>
                                                </Card>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            </ScrollShadow>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex items-center container mx-auto px-9 gap-12 pb-12">
                <h2 className="md:text-6xl text-4xl">The First - All in one Popup!</h2>
            </div>
            <div className="flex flex-col items-center container mx-auto px-9 gap-12 md:flex-row">
                <div className="flex flex-col ">
                    <div className="flex my-2 gap-2">
                        <Image
                            width={32}
                            src={GmailLogo}
                            alt="Gmail logo"
                            className=""
                        />
                        <Image
                            width={32}
                            src={OutlookLogo}
                            alt="Gmail logo"
                        />
                    </div>
                    <div className="flex flex-col gap-2 mb-8">
                        <p className=" max-w-[700px] text-lg mb-2 md:text-2xl">
                            We've created the first-ever popup that lets you compose and send emails directly, streamlining your communication without ever needing to leave the page.
                        </p>
                        <div>
                            <p className="max-w-[500px] md:text-lg text-sm">You can use our Extension to send emails with either Outlook or Gmail - it's your choice.</p>
                        </div>
                    </div>

                </div>
                <div>
                    <Image
                        width={400}
                        src={ImageComposeSection}

                    />
                </div>
            </div>
            <div className="container mx-auto px-9 flex flex-col items-center gap-2.5 py-3">
                <section className="container mx-auto px-4 py-8">
                    <div className="text-center">
                        <h2 className="text-4xl">Write Emails with Ease</h2>
                        <p className="text-sm mt-2">
                            Never start emails from scratch. Choose from our customizable templates.
                        </p>
                    </div>
                </section>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-8">
                    {benefits.map((benefit, index) => (
                        <Card key={index} className="max-w-[400px] px-5 py-3">
                            <CardHeader className="flex gap-3">
                                {benefit.icon}
                                <div className="flex flex-col">
                                    <p className="text-md">{benefit.title}</p>
                                </div>
                            </CardHeader>
                            <Divider />
                            <CardBody>
                                <p className="text-sm">{benefit.description}</p>
                            </CardBody>
                        </Card>
                    ))}
                </div>

            </div>
        </div>
    );
};

export default Home;
